import { ApplicationModel } from '@base/modules/rest/application/model/application.model';
import { OrganizationModel } from '@base/modules/rest/organization/model/organization.model';
import {
  OrganizationRegisteredResponseModel
} from '@base/modules/rest/registration/response/organization-registered-response.model';
import { CurrentUserContextResponseModel } from '@base/modules/rest/user/response/current-user-context-response.model';
import { createAction, props } from '@ngrx/store';
import { ParametersModel } from '../../modules/rest/parameters/model/parameters.model';
import { OrganizacijaModel } from '../../modules/rest/mis4/O/organizacija.model';
import { StrategijskaPoslovnaJedinicaModel } from '../../modules/rest/mis4/S/strategijska-poslovna-jedinica.model';
import { PoslovnaGodinaModel } from '../../modules/rest/mis4/P/poslovna-godina.model';
import { EmployeeModel } from '../../modules/rest/user/model/employee.model';
import { OrganizacionaJedinicaModel } from '../../modules/rest/mis4/O/organizaciona-jedinica.model';

export const LoadAppPublicData = createAction(
  '[Core - preload] Load app public data'
);

export const LoadAppPublicDataSuccess = createAction(
  '[Core - preload] Load app public data success',
  props<{
    parameters: ParametersModel;
    organizationRegisteredResponse: OrganizationRegisteredResponseModel;
  }>()
);

export const LoadAppPublicDataFailed = createAction(
  '[Core - preload] Load app public data failed'
);

export const LoadAppSecuredData = createAction(
  '[Core - preload] Load app secured data'
);

export const LoadAppSecuredDataSuccess = createAction(
  '[Core - preload] Load app secured data success',
  props<{
    parameters: ParametersModel;
    currentUserContextResponse: CurrentUserContextResponseModel;
    applications: ApplicationModel[];
    organizations: OrganizationModel[];
    hasActiveLicense: boolean;
    aktivnaOrganizacija: OrganizacijaModel;
    spj: StrategijskaPoslovnaJedinicaModel;
    poslovnaGodina: PoslovnaGodinaModel;
    organizacionaJedinica: OrganizacionaJedinicaModel;
    employeeInfo: EmployeeModel;
  }>()
);

export const ReloadApplications = createAction(
  '[Core - application] Reload applications'
);

export const ReloadApplicationsSuccess = createAction(
  '[Core - application] Reload applications success',
  props<{ applications: ApplicationModel[] }>()
);
